import type { HTMLAttributes } from 'react';
import type { BreadcrumbData } from '@trg/api';
import { Link } from '../link';
import { Icon } from '../icon';

export type BreadcrumbProps = Omit<HTMLAttributes<HTMLElement>, 'children'> & {
  navList?: BreadcrumbData[];
  hideLastArrow?: boolean;
};

export function Breadcrumb({
  navList = [],
  hideLastArrow,
  ...props
}: BreadcrumbProps) {
  const judgeLastArrowVisibility = (index: number) => {
    return index !== navList.length - 1 || !hideLastArrow;
  };

  return (
    <nav {...props}>
      <ul className="tlw-flex">
        {navList.map(({ title, link }, i) => (
          <li
            key={title}
            className="tlw-txt-zh-head-8 tlw-text-txt-600 tlw-p-1 tlw-pl-0 tlw-flex tlw-items-center tlw-gap-1"
          >
            <Link
              className="tlw-truncate tlw-max-w-[8em] hover:tlw-text-txt-core lg:tlw-max-w-[12em]"
              href={link}
            >
              {title}
            </Link>

            {judgeLastArrowVisibility(i) && <Icon name="Right" size={16} />}
          </li>
        ))}
      </ul>
    </nav>
  );
}
